const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export const captureUtms = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v;
  });
  if (Object.keys(found).length) {
    localStorage.setItem("utm", JSON.stringify(found));
  }
};

export const getUtms = () => {
  try {
    return JSON.parse(localStorage.getItem("utm") || "{}");
  } catch {
    return {};
  }
};
